import apiService from "./../../../../server";
import { ORG_ROLE, ORG_ROLE_PRIVILEGES, ORG_ROLES } from "../api";

export function fetchOrgRoles(page = 0, size = 20) {
    return apiService.get(ORG_ROLES, { params: { page, size } });
}

export function fetchOrgRole(roleName: string) {
    return apiService.get(ORG_ROLE, { params: { roleName } });
}

export function createOrgRole(data: object) {
    return apiService.post(ORG_ROLE, data);
}

export function updateOrgRole(data: object) {
    return apiService.put(ORG_ROLE, data);
}

export function updateOrgRolePrivileges(data: { role: string; privileges: Array<{ key: string; status: boolean }> }) {
    return apiService.post(ORG_ROLE_PRIVILEGES, data);
}
